import React from "react";
import ImageButton from "../../script/common/ImageButton";
import nextButtonImage from "../../image/Buttons/HorizontalNextPage/next.png";
import nextButtonHoverImage from "../../image/Buttons/HorizontalNextPage/next_hover.png";
import nextButtonClickImage from "../../image/Buttons/HorizontalNextPage/next_click.png";
import "./HorizontalNextPageButton.css";

interface Props {
  isDisabled: boolean;
  onClick: () => void;
}

const HorizontalNextPageButton = ({ isDisabled, onClick }: Props) => {
  return (
    <div className="horizontal-next-page-button-scale">
      <ImageButton
        isDisabled={isDisabled}
        defaultImagePath={nextButtonImage}
        hoverImagePath={nextButtonHoverImage}
        clickedImagePath={nextButtonClickImage}
        disabledImagePath={nextButtonClickImage}
        onClick={onClick}
      />
    </div>
  );
};

export default HorizontalNextPageButton;
